import {
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React from "react";

function BillingStmtSummary({ billingstmtsummary }) {
  return (
    <>
      <MDBTable>
        <MDBTableHead>
          <tr>
            <th scope="col">Month-Year</th>
            <th scope="col">Actions</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {billingstmtsummary &&
            billingstmtsummary.length > 0 &&
            billingstmtsummary.map((statement) => (
              <>
                <tr>
                  <th scope="row">{statement.month_year}</th>
                  <td className="">
                    <a href="" className="AddToolTip">
                      <MDBIcon far icon="eye" color="primary" />
                    </a>
                    <a href="" className="ms-3 deleteToolTip">
                      <MDBIcon fas icon="download" color="primary" />
                    </a>
                  </td>
                </tr>
              </>
            ))}
        </MDBTableBody>
      </MDBTable>
    </>
  );
}

export default BillingStmtSummary;
